// Helper function to convert specialty to practitioner format
export const formatSpecialty = (specialty) => {
	if (!specialty) return "Healthcare Professional";

	if (specialty.endsWith("ology")) {
		return specialty.replace(/ology$/, "ologist");
	}

	if (specialty.endsWith("ist")) {
		return specialty;
	}

	return specialty;
};

// Get peer comparison status
export const getPeerComparisonStatus = (userScore, peerAverage) => {
	const diff = userScore - peerAverage;
	if (diff > 0.5) {
		return { label: "Higher than peer average", bgColor: "bg-green-50", color: "text-green-600", borderColor: "border-green-200" };
	} else if (diff < -0.5) {
		return { label: "Lower than peer average", bgColor: "bg-orange-50", color: "text-orange-600", borderColor: "border-orange-200" };
	}
	return { label: "Aligned with peers", bgColor: "bg-blue-50", color: "text-blue-600", borderColor: "border-blue-200" };
};

// Get comparison styles for competitor comparison
export const getComparisonStyles = (comparison) => {
	const styles = {
		"Much Better": {
			bg: "bg-green-50",
			border: "border-green-300",
			text: "text-green-700",
			iconColor: "text-green-600"
		},
		"Better": {
			bg: "bg-blue-50",
			border: "border-blue-300",
			text: "text-blue-700",
			iconColor: "text-blue-600"
		},
		"Same": {
			bg: "bg-purple-50",
			border: "border-purple-300",
			text: "text-purple-700",
			iconColor: "text-purple-600"
		},
		"Worse": {
			bg: "bg-yellow-50",
			border: "border-yellow-300",
			text: "text-yellow-700",
			iconColor: "text-yellow-600"
		}
	};

	return styles[comparison] || {
		bg: "bg-red-50",
		border: "border-red-300",
		text: "text-red-700",
		iconColor: "text-red-600"
	};
};

// Static data for each review card
export const getStaticData = (review) => ({
	confidenceScore: 85,
	confidenceCategory: "Usually",
	accessibilityScore: review?.accessibilityScore || 75,
	accessibilityCategory: review?.accessibilityCategory || "Good",
	competitorComparison: "Better",
	competitorName: "Semaglutide",
	clinicalInsight: "Improved insurance coverage and patient assistance programs would significantly increase prescribing. The efficacy data is compelling, but access barriers remain a primary concern.",
	experience: "100+ patients with this medication"
});

// Peer averages for comparison
export const peerAverages = {
	efficacy: 4.2,
	safety: 4.0,
	tolerability: 3.8,
	adherence: 4.8,
	priceandaffordability: 3.2,
	preference: 4.3,
	accessibility: 68,
	confidence: 79
};

// Rating categories generator
export const getRatingCategories = (review) => [
	{ tag: 'efficacy', label: 'Efficacy', value: review?.efficacy || 0 },
	{ tag: 'safety', label: 'Safety', value: review?.safety || 0 },
	{ tag: 'tolerability', label: 'Tolerability', value: review?.tolerability || 0 },
	{ tag: 'adherence', label: 'Adherence', value: review?.adherence || 0 },
	{ tag: 'priceandaffordability', label: 'Price/Affordability', value: review?.priceandaffordability || 0 }
];

export const CLINICAL_CONCERN = {
	MIN: 0,
	MAX: 2
}
